module.exports = __webpack_public_path__ + "static/media/04.eb7159a5.png";